/**
 * 画面幅がモバイルかを返す hook (2026-07-29)。
 *
 * 用途:
 *   - AppLayout: サイドバーをドロワー化 / 下部タブバーを出す
 *   - 掲示板: モバイル専用コンポーネントへ出し分け
 *
 * 実装方針:
 *   - matchMedia を使い、回転・リサイズに追従する
 *   - SSR は無いので初期値も matchMedia から取れる（初回レンダリングのちらつき防止）
 *   - 境界は 768px（tailwind の md）。これ未満をモバイルとする
 */
import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 768;

const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

function readMatch(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(readMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    // 初期値のズレ（マウント前に幅が変わった場合）を補正
    setIsMobile(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isMobile;
}
